var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "glide" }, [
    _c(
      "div",
      { staticClass: "glide__track", attrs: { "data-glide-el": "track" } },
      [
        _c(
          "ul",
          { staticClass: "glide__slides" },
          _vm._l(_vm.items, function(item, index) {
            return _c("AppSliderItem", { key: index, attrs: { item: item } })
          }),
          1
        )
      ]
    ),
    _vm.items.length > 1
      ? _c(
          "div",
          {
            staticClass: "glide__arrows",
            attrs: { "data-glide-el": "controls" }
          },
          [
            _c(
              "button",
              {
                staticClass: "glide__arrow glide__arrow--left",
                attrs: { "data-glide-dir": "<" }
              },
              [_vm._v("\n      prev\n    ")]
            ),
            _c(
              "button",
              {
                staticClass: "glide__arrow glide__arrow--right",
                attrs: { "data-glide-dir": ">" }
              },
              [_vm._v("\n      next\n    ")]
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2de0d697", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2de0d697","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/AppSlider.vue
// module id = Uadb
// module chunks = 0 1 2 5